/**
 * (c) 2021, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
import { ReactComponent as PythonLogo } from "./python-logo.svg";

/**
 * The Python logo.
 */
export default PythonLogo;
